declare module '#app' {
  interface NuxtApp {
    $internalPublicApi: typeof $fetch
  }
}

export default defineNuxtPlugin(() => {
  const { app } = useRuntimeConfig()
  const internalPublicApi = $fetch.create({
    baseURL: `${app.baseURL}/api/intern/public`,
  })
  return {
    provide: {
      internalPublicApi,
    },
  }
})
